interface ErrorLocationProps {
  filename?: string;
  lineno?: number;
  colno?: number;
  zoomScale?: string;
}

export function ErrorLocation({
  filename = "unknown",
  lineno = 1,
  colno = 1,
  zoomScale = "1",
}: ErrorLocationProps) {
  return (
    <div
      className="bg-secondary-100 text-white px-3 py-2 font-mono text-xs shrink-0"
      style={{
        fontSize: `calc(11px * ${zoomScale})`,
      }}
    >
      <div className="flex items-center gap-1 overflow-x-auto whitespace-nowrap leading-normal">
        <span className="text-secondary-n-200">at</span>
        <span className="text-blue-400">{filename}</span>
        <span className="text-secondary-n-200">
          :{lineno}:{colno}
        </span>
      </div>
    </div>
  );
}

export default ErrorLocation;
